import createChangedCampaignNoteEntry from '../helpers/createChangedCampaignNoteEntry.js'
import isCampaignNoteChanged from '../helpers/isCampaignNoteChanged.js'
import isEmpty from '../helpers/isEmpty.js'
//-----------------------------
// track campaign note changes
//-----------------------------
export default function trackCampaignNoteChanges({
  change = null,
  campaign_note,
  original_campaign_notes,
  changed_campaign_notes,
  character_id,
  delete: del = false,
} = {}) {
  console.log('===================================================')
  console.log('IN trackCampaignNoteChanges')
  console.log('campaign_note = ', window.$deepCopy(campaign_note))
  console.log('change = ', window.$deepCopy(change))
  console.log('original_campaign_notes = ', window.$deepCopy(original_campaign_notes))
  console.log('changed_campaign_notes = ', window.$deepCopy(changed_campaign_notes))
  console.log('del = ', del)
  console.log('----------------------------------')
  //---------------------
  // check args received
  //---------------------
  if (
    isEmpty(campaign_note) ||
    original_campaign_notes === undefined ||
    changed_campaign_notes === undefined
  ) {
    return []
  }
  /*
  -------------------------------------------------------------------------------------------------------------------------
   CHANGED ARRAY    ORIGINAL ARRAY     PARM ACTION         CHANGED ARRAY ACTION
  ---------------  ----------------   ------------         ---------------------
  A.    No               No               ADD              add (new character campaign note)
  B.    No               Yes              UPDATE           add existing character campaign note update
  C.    Yes              Yes              UPDATE/REMOVE    further character campaign note update or reverting to original)
  D.    Yes              No               ADD              update same ADD entry (further updates having flagged addition)
  -------------------------------------------------------------------------------------------------------------------------
  */
  let campaign_note_changed_parm = {}
  //------------------------------------------------------------------------------------------
  // set campaign note name for change entry (use display name if exists - otherwise static campaign note name)
  //------------------------------------------------------------------------------------------
  // const campaign_note_name = campaign_note.display_name ? campaign_note.display_name : campaign_note.updated_at
  //---------------------------------------------------------------------------------
  // find campaign note in change array (using id if existing campaign note - or temp id for new campaign note)
  //---------------------------------------------------------------------------------
  const changed_idx = changed_campaign_notes.findIndex((c) =>
    campaign_note.id != null ? c.id === campaign_note.id : null,
  )
  // console.log('XXXXX changed_idx = ', changed_idx)
  //-----------------------------------------------------------------------------
  // find campaign note in original array (wont be an original entry without id)
  //-----------------------------------------------------------------------------
  // const original_idx = original_campaign_notes.findIndex((o) => o.id === campaign_note.id)
  const notes = Array.isArray(original_campaign_notes) ? original_campaign_notes : []
  const original_idx = notes.findIndex((o) => o.id === campaign_note.id)
  //-----------------
  // get note values
  //-----------------
  const updated_at = campaign_note.name
    ? campaign_note.name
    : campaign_note.updated_at
      ? campaign_note.updated_at
      : ''
  const note =
    campaign_note.note ?? (change?.key === 'note' ? change.value : (campaign_note.value ?? ''))
  const session_date =
    campaign_note.session_date ?? (change?.key === 'session_date' ? change.value : '')
  //=========================================================================================================================
  // A. where campaign note NOT in change array + NOT in original array (adding new character campaign note)
  //---------------------------------------------------------------------------------------------------------
  if (changed_idx == -1 && original_idx == -1) {
    console.log('A. CAMPAIGN NOTE NOT IN CHANGED OR ORIGINAL ARRAY NAME = ', updated_at)
    //----------------------------------
    // from characterSheetCampaignNotes
    //----------------------------------
    campaign_note_changed_parm = createChangedCampaignNoteEntry({
      campaign_note_updated_at: updated_at,
      id: campaign_note.id, // real or temp id used for tracking
      action: 'ADD',
      payload: {
        character: character_id ? character_id : null,
        updated_at: updated_at,
        note: note,
        session_date,
      },
    })
    changed_campaign_notes.push(campaign_note_changed_parm)
    //===========================================================================================================================
    // B. where campaign note NOT in change array + IS in original array (deleting or updating existing character campaign note)
    //---------------------------------------------------------------------------------------------------------------------------
  } else if (changed_idx == -1 && original_idx !== -1) {
    console.log('B. CAMPAIGN NOTE NOT IN CHANGED ARRAY + IS IN ORIGINAL ARRAY: ' + updated_at)
    //----------------------------------------
    // where deleting character campaign note
    //----------------------------------------
    if (del) {
      console.log('B1. CREATE DELETION ENTRY')
      //--------------------
      // add deletion entry
      //--------------------
      campaign_note_changed_parm = createChangedCampaignNoteEntry({
        campaign_note_updated_at: updated_at,
        action: 'DELETE',
        id: campaign_note.id, // character_campaign_note id or temp id
      })
      //------------------
      // add update entry
      //------------------
    } else {
      console.log('B2. CREATE UPDATE ENTRY')
      campaign_note_changed_parm = {
        campaign_note_updated_at: updated_at,
        action: 'UPDATE',
        id: campaign_note.id, // character_campaign_note id or temp id
        payload: {
          [change.key]: change.value,
        },
      }
    }
    changed_campaign_notes.push(campaign_note_changed_parm)
    //=========================================================================================================================
    // C. where campaign note IS in change array + IS in original array (updating existing change entry/remove if reverted)
    //----------------------------------------------------------------------------------------------------------------------
  } else if (changed_idx !== -1 && original_idx !== -1) {
    console.log('C. CAMPAIGN NOTE IS IN CHANGED ARRAY + IS IN ORIGINAL ARRAY: ' + updated_at)
    console.log('C1. CHECK IF CAMPAIGN NOTE CHANGED')
    //--------------------------------
    // where deleting character campaign note
    //--------------------------------
    if (del) {
      console.log('C2. CREATE DELETION ENTRY')
      //---------------------------------
      // remove change entry where found
      //---------------------------------
      changed_campaign_notes.splice(changed_idx, 1)
      //--------------------
      // add deletion entry
      //--------------------
      campaign_note_changed_parm = createChangedCampaignNoteEntry({
        campaign_note_updated_at: updated_at,
        action: 'DELETE',
        id: campaign_note.id, // character_campaign_note id or temp id
      })
      changed_campaign_notes.push(campaign_note_changed_parm)
      //--------------
      // not deleting
      //--------------
    } else {
      //-----------------------------------------------------------------
      // check if values changed (could have reverted back to originals)
      //-----------------------------------------------------------------
      let campaign_note_changed = isCampaignNoteChanged(
        original_campaign_notes[original_idx],
        campaign_note,
      )
      //---------------
      // value changed
      //---------------
      if (campaign_note_changed) {
        console.log('C3. CAMPAIGN NOTE VAL CHANGED - UPDATE ENTRY: ' + updated_at)
        //--------------------
        // update campaign note entry
        //--------------------
        changed_campaign_notes[changed_idx].payload[change.key] = change.value
        //---------------------------------------
        // value is original - remove from array
        //---------------------------------------
      } else {
        console.log('C4. CAMPAIGN NOTE NOT CHANGED - REMOVE ENTRY: ' + updated_at)
        changed_campaign_notes.splice(changed_idx, 1)
      }
    }
    //=========================================================================================================================
    // D. where campaign note IS in change array + NOT in original array (updating and add entry - further changes before commit
    //------------------------------------------------------------------------------------------------------------------
  } else {
    console.log('D. CAMPAIGN NOTE IS IN CHANGED ARRAY + NOT IN ORIGINAL ARRAY: ' + updated_at)
    //-----------------------------------------
    // where local campaign note being deleted
    //-----------------------------------------
    if (del) {
      console.log('D1. NEW CAMPAIGN NOTE BEING DELETED - REMOVE ENTRY: ' + updated_at)
      changed_campaign_notes.splice(changed_idx, 1)
    } else {
      console.log('D2. UPDATE THE UPDATE ENTRY')
      //----------------------------
      // update campaign note entry
      //----------------------------
      console.log(
        'D3. changed_campaign_notes[changed_idx] = ',
        window.$deepCopy(changed_campaign_notes[changed_idx]),
      )
      console.log('D4. change = ', change)
      changed_campaign_notes[changed_idx].payload[change.key] = change.value
    }
  }
  console.log(
    '##################### UPDATED changed_campaign_notes = ',
    window.$deepCopy(changed_campaign_notes),
  )
  console.log('===================================================')
  return changed_campaign_notes
}
